<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('media', {
            isLoading: state => state.isLoading,
            tags: state => state.tags,
            folders: state => state.folders,
            types: state => state.types,
            totalTypeCount: state => state.totalTypeCount,
            activeTags: state => state.activeTags,
            activeFolders: state => state.activeFolders
        })
    },

    methods: {
        onChange(value) {
            this.$parent.$emit('folderChange', value);
            this.$store.commit('media/set', {
                activeFolders: value
            });
        }
    }
}
</script>

<template>
    <list-group-select
        class="list-group--folders"
        :options="folders"
        :value="activeFolders"
        label="name"
        checkAllLabel="All Folders"
        searchPlaceholder="Find a folder"
        emptyResults="No folders found"
        @onChange="onChange">
    </list-group-select>
</template>
